import { render, staticRenderFns } from "./ContactPhones.vue?vue&type=template&id=995d7d8e"
import script from "./ContactPhones.vue?vue&type=script&lang=js"
export * from "./ContactPhones.vue?vue&type=script&lang=js"
import style0 from "./ContactPhones.vue?vue&type=style&index=0&id=995d7d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports